import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import { FaBars, FaTimes } from 'react-icons/fa';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleServicesDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsModalOpen(false); // Close modal when screen size is above 768px
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header>
      <div className="logo-container">
        {/* Reference the logo from the public folder */}
        <img src="/logo192.png" alt="Logo" className="logo" />
        <div className="logo-text">VitalHands Care</div>
      </div>
      
      <div className={`mobile-menu-modal ${isModalOpen ? 'open' : ''}`}>
        <div className="mobile-menu-overlay" onClick={toggleMobileMenu}></div>
        <div className="mobile-menu-content">
          <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
            <FaTimes />
          </div>
          <nav className="nav-links">
            <div>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link>
            </div>
            
            <div className="dropdown" onClick={toggleServicesDropdown}>
              <Link to="/services" className={location.pathname === '/services' ? 'active' : ''}>Services</Link>
              {isDropdownOpen && (
                <div className="dropdown-menu">
                  <Link to="/service1">Service 1</Link>
                  <Link to="/service2">Service 2</Link>
                </div>
              )}
            </div>
            <div>
              <Link to="/careers" className={location.pathname === '/careers' ? 'active' : ''}>Careers</Link>
            </div>
            <div>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link>
            </div>
            <div>
              <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About Us</Link>
            </div>
          </nav>
        </div>
      </div>
      <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
        <FaBars />
      </div>
    </header>
  );
};

export default Header;
